import { UseMutationOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import { BidChatMutation, BidChatMutationVariables } from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../../useGraphQlClient";

const bidChatQuery = graphql(`
  mutation BidChat($req: BidChatRequest!) {
    bidChat(BidChatRequest: $req) {
      conversationId
      question
    }
  }
`);

export type BidChatQuestion = BidChatMutation["bidChat"];
export function useBidChat(
  options?: UseMutationOptions<BidChatMutation, unknown, BidChatMutationVariables, unknown>,
) {
  const { data, ...rest } = useGraphQlMutation(bidChatQuery, {
    ...options,
  });

  return { data: data?.bidChat, ...rest };
}
